import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { getConfig } from '@edx/frontend-platform';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useHeaderFooter, useCoursePreview } from '../../hooks';
import { getLmsCourseNotesUrl, getLmsCourseProgressUrl } from '../../utils';
import { CourseNavigation } from '../../components';

import '../../scss/CourseWorking.scss';
import messages from './messages';

import arrowLeftImg from '../../img/arrow-left-blue.svg';
import arrowRightImg from '../../img/arrow-right-blue.svg';

interface CourseProgressProps {
  children?: React.ReactNode;
}

const CourseProgress: React.FC<CourseProgressProps> = ({ children }) => {
  const [edxIframeUrl, setEdxIframeUrl] = useState<string>('');
  const [isCourseProgress, setIsCourseProgress] = useState<boolean>(false);

  const intl = useIntl();
  const { pathname } = useLocation();
  const { courseID = '' } = useParams<{ courseID: string }>();
  const { headerContent, footerContent } = useHeaderFooter(children);
  const { courseInfo } = useCoursePreview(courseID);

  const populateCourseProgress = (): void => {
    getLmsCourseProgressUrl(courseID, (url: string): void => setEdxIframeUrl(url));
  };

  const populateCourseNotes = (): void => {
    getLmsCourseNotesUrl(courseID, (url: string): void => setEdxIframeUrl(url));
  };

  useEffect(() => {
    populateCourseProgress();
  }, [courseID]);

  useEffect(() => {
    if (pathname.includes('course-notes')) {
      populateCourseNotes();
      setIsCourseProgress(false);
    } else if (pathname.includes('course-progress')) {
      populateCourseProgress();
      setIsCourseProgress(true);
    }
  }, [pathname]);

  return (
    <>
      <input
        type="hidden"
        id="anPageName"
        name="page"
        defaultValue="course-progress"
      />
      <div className="container-center-horizontal progress-div">
        <div className="course-progress screen">
          <div className="overlap-group8">
            <div className="overlap-group6">
              <div className="hero-image">
                <div className="overlap-group">
                  {courseInfo?.banner_image_asset_path && (
                    <img
                      className="inbal-marilli-lg-ui"
                      src={`${getConfig().LMS_BASE_URL}${courseInfo?.banner_image_asset_path}`}
                      alt=""
                    />
                  )}
                  <div className="rectangle-20" />
                </div>
              </div>
              <div className="headline">
                <h1 className="course-01-why-lead instrumentserif-normal-white-100-1px-2">
                  <span className="instrumentserif-normal-white-100-1px">
                    {intl.formatMessage(messages.module)}
                    <br />
                  </span>
                  <span className="recklessneue-regular-normal-white-100-1px c_title">
                    {courseInfo?.display_name}
                  </span>
                </h1>
              </div>
            </div>
            {headerContent}
            <div id="page-nav">
              <div className="page-nav">
                <div className="nav-cont">
                  <div className="progress-nav">
                    <img
                      className="arrow-1 arrow nav_btn previous_btn"
                      src={arrowLeftImg}
                      alt="Arrow Left"
                    />
                    <p className="chapter-one-what-to-expect recklessneue-book-normal-congress-blue-22-8px c-active">
                      {courseInfo?.display_name}
                    </p>
                    <img
                      className="arrow nav_btn next_btn"
                      src={arrowRightImg}
                      alt="Arrow Right"
                    />
                  </div>
                  <CourseNavigation courseID={courseID} />
                </div>
              </div>
            </div>
          </div>
          {isCourseProgress && (
            <div className="course-progress-intro-text">
              <div className="course-progress-1">
                {intl.formatMessage(messages.moduleProgress)}
              </div>
              <p className="this-page-shows-your neuehaasgroteskdisplaypro-45-light-congress-blue-24px">
                {intl.formatMessage(messages.progressIntro)}
              </p>
            </div>
          )}
          <div className="legatum-container">
            <iframe
              id="edx-iframe"
              title={intl.formatMessage(messages.iframeTitle)}
              sandbox="allow-modals allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox allow-downloads"
              frameBorder={0}
              src={edxIframeUrl}
              className="notes-iframe"
              allowFullScreen
            />
          </div>
          {footerContent}
        </div>
      </div>
    </>
  );
};

export default CourseProgress;
